var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"white"},[React.createElement("path",{"d":"M1 3.5h15","key":0}),React.createElement("path",{"d":"M1 8h15","key":1}),React.createElement("path",{"d":"M1 12.5h15","key":2})]));
}

Menu.defaultProps = {"viewBox":"0 0 17 16","width":"20"};

module.exports = Menu;

Menu.default = Menu;
